import * as React from "react";
const SvgPlusCustom = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-5da9631c-a0ab-41d0-9d5c-4db0f1b3dfba", "data-name": "uuid-f2619d4d-5adf-466c-9e22-b2c89a1ba0ef", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m8.75,0h-1.5v7.25H0v1.5h7.25v7.25h1.5v-7.25h7.25v-1.5h-7.25V0Z", style: {
  fill: "currentColor",
  strokeWidth: 0
} }));
export default SvgPlusCustom;
